import { useMutation } from '@tanstack/react-query';
import { submitDemoRequest } from './demoRequestsApi';

export function useSubmitDemoLead() {
  return useMutation({ mutationFn: submitDemoRequest });
}
